import { useEffect } from 'react'
import { appConfig } from '@/config/app'
import { buildAppReturnPath, redirectToAuthPortal } from '@/utils/authPortal'

type BrowserAuthRedirectProps = {
  pathname: string
  search?: string
  hash?: string
}

export const BrowserAuthRedirect: React.FC<BrowserAuthRedirectProps> = ({
  pathname,
  search = '',
  hash = '',
}) => {
  useEffect(() => {
    redirectToAuthPortal(buildAppReturnPath(pathname, search, hash))
  }, [hash, pathname, search])

  const uiColors = appConfig.ui.colors

  return (
    <div className={`min-h-screen ${uiColors.pageBg} flex items-center justify-center`}>
      <div className={`w-10 h-10 border-4 ${uiColors.accentBlueBorder} border-t-transparent rounded-full animate-spin`} />
    </div>
  )
}
